const S3_BASE_URL = "https://althaf-portfolio.s3.us-east-1.amazonaws.com";

export const projects = [
  {
    name: "NAS - PYP",
    description: "Welcome to the National Academy School - PYP Section !",
    mainImage: `${S3_BASE_URL}/naspyp-web/naspyp-web.webp`,
    images: [
      `${S3_BASE_URL}/naspyp-web/1.webp`,
      `${S3_BASE_URL}/naspyp-web/2.webp`,
      `${S3_BASE_URL}/naspyp-web/3.webp`,
      `${S3_BASE_URL}/naspyp-web/4.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://naspyp.com/",
    orientation: "landscape",
  },
  {
    name: "Car Loan Deal",
    description:
      "Online referral service. We partner with individual brokers & funders to provide you access to their expert teams who can assist in selecting suitable finance solutions from their panel of providers.",
    mainImage: `${S3_BASE_URL}/car-loan-deal/car-loan-deal.webp`,
    images: [
      `${S3_BASE_URL}/car-loan-deal/1.webp`,
      `${S3_BASE_URL}/car-loan-deal/2.webp`,
      `${S3_BASE_URL}/car-loan-deal/3.webp`,
      `${S3_BASE_URL}/car-loan-deal/4.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://carloandeal.com.au/",
    orientation: "landscape",
  },
  {
    name: "Best Loan Deal",
    description:
      "Best Loan Deal is an online referral service. We partner with individual brokers & funders to provide you access to their expert teams who can assist in selecting suitable finance solutions from their panel of providers.",
    mainImage: `${S3_BASE_URL}/best-loan-deal/best-loan-deal.webp`,
    images: [
      `${S3_BASE_URL}/best-loan-deal/1.webp`,
      `${S3_BASE_URL}/best-loan-deal/2.webp`,
      `${S3_BASE_URL}/best-loan-deal/3.webp`,
      `${S3_BASE_URL}/best-loan-deal/4.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://bestloandeal.com.au/",
    orientation: "landscape",
  },
  {
    name: "LYP",
    description:
      "Love Your Postcode offers free house price reports by connecting homeowners with local real estate experts in Australia.",
    mainImage: `${S3_BASE_URL}/love-your-postcode/lyp.webp`,
    images: [
      `${S3_BASE_URL}/love-your-postcode/1.webp`,
      `${S3_BASE_URL}/love-your-postcode/2.webp`,
      `${S3_BASE_URL}/love-your-postcode/3.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://loveyourpostcode.com.au/",
    orientation: "landscape",
  },
  {
    name: "Aduppankarai",
    description: "Restaurant POS software Dining Experience with Digital Menus",
    mainImage: `${S3_BASE_URL}/Aduppankarai/aduppankarai.webp`,
    images: [
      `${S3_BASE_URL}/Aduppankarai/1.webp`,
      `${S3_BASE_URL}/Aduppankarai/2.webp`,
      `${S3_BASE_URL}/Aduppankarai/3.webp`,
      `${S3_BASE_URL}/Aduppankarai/4.webp`,
      `${S3_BASE_URL}/Aduppankarai/5.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://aduppankarai-y37u.vercel.app/",
    orientation: "landscape",
  },
  {
    name: "Let's Go",
    description: "Welcome to the Ultimate Biker's Community App!!",
    mainImage: `${S3_BASE_URL}/lets-go/lets_go.webp`,
    images: [
      `${S3_BASE_URL}/lets-go/1.webp`,
      `${S3_BASE_URL}/lets-go/2.webp`,
      `${S3_BASE_URL}/lets-go/3.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "",
    orientation: "portrait",
  },
  {
    name: "PopAppz",
    description:
      "Global destination for specialized IT solutions, ideal for startups and businesses seeking to enhance their digital presence.",
    mainImage: `${S3_BASE_URL}/popappz/popappz.webp`,
    images: [
      `${S3_BASE_URL}/popappz/1.webp`,
      `${S3_BASE_URL}/popappz/2.webp`,
      `${S3_BASE_URL}/popappz/3.webp`,
      `${S3_BASE_URL}/popappz/4.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://popappz.com",
    orientation: "landscape",
  },
  {
    name: "Lingam ERP",
    description:
      "Lingam ERP is a billing app for efficient invoicing and sales management.",
    mainImage: `${S3_BASE_URL}/lingam-erp/lingam_inventory.webp`,
    images: [
      `${S3_BASE_URL}/lingam-erp/1.webp`,
      `${S3_BASE_URL}/lingam-erp/2.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "",
    orientation: "portrait",
  },
  {
    name: "Flyashop",
    description:
      "Flyashop powers businesses of all shapes and sizes build and scale globally — from hey people to a billion dollar unicorn.",
    mainImage: `${S3_BASE_URL}/Flyashop/flyashop.webp`,
    images: [
      `${S3_BASE_URL}/Flyashop/1.webp`,
      `${S3_BASE_URL}/Flyashop/2.webp`,
      `${S3_BASE_URL}/Flyashop/3.webp`,
      `${S3_BASE_URL}/Flyashop/4.webp`,
      `${S3_BASE_URL}/Flyashop/5.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://flyashop.com",
    orientation: "landscape",
  },
  {
    name: "Trustrong",
    description:
      '"Trustrong" is a award-winning full-service construction company',
    mainImage: `${S3_BASE_URL}/trustrong/Trustrong.webp`,
    images: [
      `${S3_BASE_URL}/trustrong/1.webp`,
      `${S3_BASE_URL}/trustrong/2.webp`,
      `${S3_BASE_URL}/trustrong/3.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://trustrongdeveloper.com//",
    orientation: "landscape",
  },
  // {
  //   name: "Codemagen",
  //   description:
  //     '"Codemagen" – Your Ultimate Travel Companion. This web application lets you seamlessly book flight tickets and hotels, making your travel experience effortless and enjoyable.',
  //   mainImage: Codemagen,
  //   android_link: "",
  //   ios_link: "",
  //   web_link: "",
  //   orientation: "landscape",
  // },
  {
    name: "Brouduct",
    description:
      "This is an E-commerce Platform, The ultimate platform that bridges the gap between local shops and savvy shoppers.",
    mainImage: `${S3_BASE_URL}/Brouduct/Brouduct.webp`,
    images: [
      `${S3_BASE_URL}/Brouduct/1.webp`,
      `${S3_BASE_URL}/Brouduct/2.webp`,
      `${S3_BASE_URL}/Brouduct/3.webp`,
      `${S3_BASE_URL}/Brouduct/4.webp`,
      `${S3_BASE_URL}/Brouduct/5.webp`,
    ],
    android_link:
      "https://play.google.com/store/apps/details?id=com.brouduct.ecommerce",
    ios_link: "",
    web_link: "",
    orientation: "portrait",
  },
  {
    name: "Learning Info",
    description:
      "This is a School Management Software, Learning Info Platform offers a combination of all the digital tools required by a school.",
    mainImage: `${S3_BASE_URL}/learning-info/LearningInfo.webp`,
    images: [
      `${S3_BASE_URL}/learning-info/1.webp`,
      `${S3_BASE_URL}/learning-info/2.webp`,
      `${S3_BASE_URL}/learning-info/3.webp`,
      `${S3_BASE_URL}/learning-info/4.webp`,
      `${S3_BASE_URL}/learning-info/5.webp`,
    ],
    android_link:
      "https://play.google.com/store/apps/details?id=com.LearningInfo.SchoolManagement",
    ios_link: "",
    web_link: "",
    orientation: "portrait",
  },
  {
    name: "Madhuri Portfolio",
    description:
      "An online portfolio is an excellent reflection of who you are as a person and a professional.",
    mainImage: `${S3_BASE_URL}/Madhuri-Portfolio/MadhuriPortfolio.webp`,
    images: [
      `${S3_BASE_URL}/Madhuri-Portfolio/1.webp`,
      `${S3_BASE_URL}/Madhuri-Portfolio/2.webp`,
      `${S3_BASE_URL}/Madhuri-Portfolio/3.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://madhuri-khatri-portfolio.vercel.app/",
    orientation: "landscape",
  },
  {
    name: "Mahnoor Portfolio",
    description:
      "An online portfolio is an excellent reflection of who you are as a person and a professional.",
    mainImage: `${S3_BASE_URL}/Mahnoor-Portfolio/MahnoorPortfolio.webp`,
    images: [
      `${S3_BASE_URL}/Mahnoor-Portfolio/1.webp`,
      `${S3_BASE_URL}/Mahnoor-Portfolio/2.webp`,
      `${S3_BASE_URL}/Mahnoor-Portfolio/3.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://mahnoor-aman-portfolio.vercel.app/",
    orientation: "landscape",
  },
  // {
  //   name: "Nikah 2 Muslim",
  //   description:
  //     "Nikah 2 Muslim is a dedicated matrimonial platform tailored specifically for the Muslim community.",
  //   mainImage: Nikah2Muslim,
  //   android_link: "",
  //   ios_link: "",
  //   web_link: "",
  //   orientation: "landscape",
  // },
  {
    name: "NAS-PYP",
    description:
      "This is a School Management Software, National Academy School (PYP Section) Platform offers a combination of all the digital tools required by a school.",
    mainImage: `${S3_BASE_URL}/naspyp-app/naspyp-app.webp`,
    images: [
      `${S3_BASE_URL}/naspyp-app/1.webp`,
      `${S3_BASE_URL}/naspyp-app/2.webp`,
      `${S3_BASE_URL}/naspyp-app/3.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "",
    orientation: "portrait",
  },
  {
    name: "My Portfolio",
    description:
      "An online portfolio is an excellent reflection of who you are as a person and a professional.",
    mainImage: `${S3_BASE_URL}/my-portfolio/MyPortfolio.webp`,
    images: [
      `${S3_BASE_URL}/my-portfolio/1.webp`,
      `${S3_BASE_URL}/my-portfolio/2.webp`,
      `${S3_BASE_URL}/my-portfolio/3.webp`,
      `${S3_BASE_URL}/my-portfolio/4.webp`,
    ],
    android_link: "",
    ios_link: "",
    web_link: "https://althaf-portfolio.vercel.app/",
    orientation: "landscape",
  },
];
